import { DATES_MAPPING } from '@eventbrite/discover-utils';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { gettext } from '@eventbrite/i18n';
import { ClockIcon, Typography } from '@eventbrite/marmalade';
import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { handleApplyFilter } from '../../../../../redux/actions/search';
import { DiscoverState } from '../../../../../types';

import styles from './TimeOptionsSection.module.scss';

interface TimeOptionsSectionProps {
    handleApplyDateFilter: Function;
    searchDates?: string[];
}

const TIME_OPTIONS: (keyof typeof DATES_MAPPING)[] = [
    'today',
    'tomorrow',
    'this_weekend',
    'this_week',
    'next_week',
    'this_month',
    'next_month',
];

export const TimeOptionsSection = ({
    handleApplyDateFilter,
    searchDates = [],
}: TimeOptionsSectionProps) => {
    const handleTimeOptionClick = useCallback(
        (time: string) => {
            if (HAS_WINDOW) {
                window.scrollTo(0, 0);
            }

            handleApplyDateFilter({ dates: time });
        },
        [handleApplyDateFilter],
    );

    const displayableTimeOptions = useMemo(
        () => TIME_OPTIONS.filter((option) => !searchDates.includes(option)),
        [searchDates],
    );

    return (
        <section className={styles.timeOptionsSection}>
            <Typography as="h2" variant="heading-sm" color="#261B36">
                {gettext('Event time options')}
            </Typography>
            <div className={styles.timeChipContainer}>
                {displayableTimeOptions.map((time) => (
                    <button
                        className={styles.timeChip}
                        onClick={() => handleTimeOptionClick(time)}
                        key={time}
                    >
                        <ClockIcon />
                        {gettext('Events %(time)s', {
                            time: DATES_MAPPING[time],
                        })}
                    </button>
                ))}
            </div>
        </section>
    );
};

export const _mapStateToProps = (state: DiscoverState) => {
    return {
        searchDates: state.search.eventSearch.dates,
    };
};

const _mapDispatchToProps = (dispatch: Function) => ({
    handleApplyDateFilter: (filter: { dates: string }) =>
        dispatch(handleApplyFilter(filter)),
});

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(TimeOptionsSection);
